import { css, DefaultTheme } from "styled-components";

import { inputSize } from "../../types";

function getFontStyles(props: { inputSize: inputSize; theme: DefaultTheme }) {
  const { inputSize } = props;

  switch (inputSize) {
    default:
    case "default":
      return props.theme.naga.typography.size.paragraphSmall;
    case "compact":
      return props.theme.naga.typography.size.paragraphXSmall;
    case "large":
      return props.theme.naga.typography.size.paragraphLarge;
  }
}

function getColorStyles(props: { error: boolean; positive: boolean }) {
  const { error, positive } = props;

  if (error) {
    return css`
      color: ${(props) => props.theme.naga.colors.foreground};
      border-color: ${(props) => props.theme.naga.colors.inputBorderError};
      background-color: ${(props) => props.theme.naga.colors.inputFillError};
    `;
  } else if (positive) {
    return css`
      color: ${(props) => props.theme.naga.colors.foreground};
      border-color: ${(props) => props.theme.naga.colors.inputBorderPositive};
      background-color: ${(props) => props.theme.naga.colors.inputFillPositive};
    `;
  }
  return css`
    color: ${(props) => props.theme.naga.colors.foreground};
    border-color: ${(props) => props.theme.naga.colors.inputBorderDefault};
    background-color: ${(props) => props.theme.naga.colors.inputFill};
  `;
}

export const getInputStyles = css<{
  inputSize: inputSize;
  error: boolean;
  positive: boolean;
  mb: string;
}>`
  border-width: 1px;
  border-style: solid;
  outline: 0;
  max-width: 100%;
  padding-left: ${(props) => props.theme.naga.spacing.padding.medium};
  padding-top: ${(props) => props.theme.naga.spacing.padding.small};
  padding-right: ${(props) => props.theme.naga.spacing.padding.medium};
  padding-bottom: ${(props) => props.theme.naga.spacing.padding.small};
  width: 100%;
  :disabled {
    cursor: not-allowed;
    background-color: ${(props) => props.theme.naga.colors.inputFillDisabled};
    border-color: ${(props) => props.theme.naga.colors.inputFillDisabled};
    color: ${(props) => props.theme.naga.colors.inputTextDisabled};
  }
  :disabled::placeholder {
    color: ${(props) => props.theme.naga.colors.inputTextDisabled};
  }
  :focus {
    background-color: ${(props) => props.theme.naga.colors.inputFillActive};
    border-color: ${(props) => props.theme.naga.colors.borderFocus};
    color: ${(props) => props.theme.naga.colors.foreground};
  }
  ::placeholder {
    color: ${(props) => props.theme.naga.colors.foregroundAlt};
  }
  border-radius: ${(props) => props.theme.naga.spacing.borderRadius.default};
  font-size: ${getFontStyles};
  ${(props) =>
    props.mb &&
    css`
      margin-bottom: ${props.mb};
    `}
  ${getColorStyles};
`;
